import { SlideAction, SlideHideConditionType, SlideHidePageCondition, TutorialSlide } from "../../tutorial.models";

export const DOCTER_OPTION_SLIDES: TutorialSlide[] = [
    {
        key: 'Option-Slides',
        title: 'Ready to Add Patients and Schedule Appointments?',
        messages: [
            { text: "You've successfully completed the settings tutorial! Would you like to learn how to add patients and schedule appointments next?" },
            { text: "You will need approximately 30 minutes to complete this", class: 'primary' }
        ],
        actionsClass: 'button-row',        //position: { vertical: 'center', horizontal: 'center' }, Test the position later.
        dimensions: { width: '450px' },

        actions: [
            {
                text: 'Now',
                color: 'primary',
                actionName: SlideAction.START_DOCTOR_FORCE_SCHEDULE_SIDE_NAV_TUTORIAL,
            },
            {
                text: 'Later',
                color: 'secondary',
                type: 'link',
                actionName: SlideAction.CLOSE_TUTORIAL,
            },
            {
                text: 'Never',
                color: 'warn',
                type: 'link',
                actionName: SlideAction.OLD_LOGIN_CONFIRM_NEVER,
            },
        ],
        position: { x: 700, y: 350 },
        hideDoNotShowAgain: true,
        hideConditions: [
            { condition: SlideHidePageCondition.USER_SEEN_ALL_VIDEOS, type: SlideHideConditionType.OR },
        ],
    },
];